import styled from "@emotion/styled"
import { Text, Title, Button } from "../../styles/common.styled"
import type { RoomBranding } from "../../../recoil/atoms/room/types"

export interface StylesProps {
  roomStyles?: RoomBranding
}

export const CheckBoxesGroup = styled.div`
  display: flex;
`

export const Container = styled.div`
  display: flex;
  padding: 1rem 0rem;
  height: 100%;
  overflow-x: hidden;
  overflow-y: hidden;
`

export const ModerationWrapper = styled.div<StylesProps>`
  padding: 0rem;
  overflow: auto;
  padding: 0rem 0.5rem 0rem 1rem;
  margin-right: 0.5rem;
  scroll-behavior: smooth;

  &::-webkit-scrollbar-track {
    background: ${({ roomStyles }) =>
      roomStyles.servicePanelElementBorder || "#cbd5e0"};
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${({ roomStyles }) =>
      roomStyles.servicePanelElementBorderOffset || "#fff"};
    border-radius: 10px;
  }
`

export const ModerationContainer = styled.div<StylesProps>`
  padding: 0.5rem;
  border: ${({ roomStyles }) =>
    roomStyles?.servicePanelElementBorder
      ? `2px solid ${roomStyles?.servicePanelElementBorder}`
      : "2px solid #ced4da"};
  border-radius: 0.3rem;
  background-color: ${({ roomStyles }) =>
    roomStyles?.servicePanelElementBackground ?? "#fff"};
`

export const ModerationTitle = styled(Title)`
  margin-bottom: 0.2rem;
  color: ${({ roomStyles }) =>
    roomStyles?.servicePanelElementPrimaryText &&
    roomStyles?.servicePanelElementPrimaryText};
`

export const ModerationSubTitle = styled(Title)`
  font-size: 12px;
  margin-bottom: 2px;
  text-transform: uppercase;
  font-weight: 700;
  color: ${({ roomStyles }) =>
    roomStyles?.servicePanelColorLabels ?? "rgba(0, 0, 0, 0.6)"};
`

export const ModerationTextTip = styled(Text)<StylesProps>`
  color: ${({ roomStyles }) =>
    roomStyles?.servicePanelElementLabels ?? "#495057"};
  font-size: ${({ isSmallWindowHeight }) =>
    isSmallWindowHeight ? "0.5625rem" : "0.8125rem"};
  line-height: 17px;
  margin-bottom: ${({ isSmallWindowHeight }) =>
    isSmallWindowHeight ? "0.2rem" : "0.4rem"};
  &:last-of-type {
    margin-bottom: 0;
  }
`

export const ModerationSettingsList = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 0.4rem;
`

export const ModerationSettingsItem = styled.div`
  width: 100%;
  margin-bottom: 3px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:last-of-type {
    margin-bottom: 0;
  }
`

export const ModerationSettingsName = styled(ModerationSubTitle)<
  StylesProps & { fontStyle?: string }
>`
  text-transform: none;
  color: ${({ roomStyles }) =>
    roomStyles?.servicePanelElementPrimaryText ?? "#000"};
  margin-bottom: 0;
  font-size: 13px;
  font-weight: 500;
  display: inline-block;
  &::first-letter {
    font-size: 12px;
  }
  font-style: ${({ fontStyle }) => fontStyle};
`

export const ModerationButton = styled(Button)`
  margin-bottom: 1rem;
  &:last-of-type {
    margin-bottom: 0.4rem;
  }
`

export const ModerationLink = styled.a<StylesProps>`
  color: ${({ roomStyles }) => roomStyles.servicePanelElementSecondaryText};
  font-size: 0.65rem;
  cursor: pointer;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-right: auto;
`
